/**
 * Converts a Latin-1 mojibake string back to proper UTF-8.
 * Needed for data that was stored as double-encoded UTF-8 (e.g. "CÃ³rdoba" → "Córdoba",
 * "CittÃ " → "Città"). Safe no-op for strings already correctly encoded.
 */
export function fixUtf8(str) {
  if (!str || typeof str !== 'string') return str;
  try {
    return decodeURIComponent(escape(str));
  } catch {
    return str;
  }
}
